var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", {
        attrs: { loading: _vm.$store.getters.shouldLoadLocal }
      }),
      _vm._v(" "),
      _vm.showChart
        ? _c("line-chart", {
            ref: "chart",
            attrs: {
              "chart-data": _vm.formattedData,
              options: _vm.chartOptions,
              height: _vm.height
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }